<template>
	<div class="vx-row">
		<div class="vx-col w-1/3">
			<vs-custom-button
				:type="page === 0 ? 'filled' : 'border'"
				@click="setStatsPage(0)"
				class="page-switch-button w-full pl-1 pr-1"
			>
				{{ $t("general") }}
			</vs-custom-button>
		</div>

		<div class="vx-col w-1/3">
			<vs-custom-button
				:type="page === 1 ? 'filled' : 'border'"
				class="page-switch-button w-full pl-1 pr-1"
				@click="setStatsPage(1)"
			>
				{{ $t("sites") }}
			</vs-custom-button>
		</div>

		<template v-if="$store.getters.getRole === 'admin'">
			<div class="vx-col w-1/3">
				<vs-custom-button
					:type="page === 2 ? 'filled' : 'border'"
					class="page-switch-button w-full pl-1 pr-1"
					@click="setStatsPage(2)"
				>
					{{ $t("managers") }}
				</vs-custom-button>
			</div>

			<div class="vx-col w-1/3 mt-2">
				<vs-custom-button
					:type="page === 3 ? 'filled' : 'border'"
					class="page-switch-button w-full pl-1 pr-1"
					@click="setStatsPage(3)"
				>
					{{ $t("refunds") }}
				</vs-custom-button>
			</div>

			<div class="vx-col w-1/3 mt-2">
				<vs-custom-button
					:type="page === 4 ? 'filled' : 'border'"
					class="page-switch-button w-full pl-1 pr-1"
					@click="setStatsPage(4)"
				>
					{{ $t("stats.penalties") }}
				</vs-custom-button>
			</div>

			<div class="vx-col w-1/3 mt-2">
				<vs-custom-button
					:type="page === 5 ? 'filled' : 'border'"
					class="page-switch-button w-full pl-1 pr-1"
					@click="setStatsPage(5)"
				>
					{{ $t("stats.fails") }}
				</vs-custom-button>
			</div>

			<div class="vx-col w-1/3 mt-2">
				<vs-custom-button
					:type="page === 6 ? 'filled' : 'border'"
					class="page-switch-button w-full pl-1 pr-1"
					@click="setStatsPage(6)"
				>
					{{ $t("stats.leeds") }}
				</vs-custom-button>
			</div>

			<div class="vx-col w-1/3 mt-2">
				<vs-custom-button
					:type="page === 7 ? 'filled' : 'border'"
					class="page-switch-button w-full pl-1 pr-1"
					@click="setStatsPage(7)"
				>
					{{ $t("answerTime") }}
				</vs-custom-button>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: "StatsButtonTabs",

	props: {
		page: {
			type: Number,
			default: 0
		}
	},

	methods: {
		setStatsPage(page) {
			this.$emit("update:page", page);
		}
	}
};
</script>

<style></style>
